export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: { input: any; output: any; }
};

/** A type */
export type Auth = {
  __typename?: 'Auth';
  /** Bearer token */
  token?: Maybe<Scalars['String']['output']>;
  /** Bearer token */
  type?: Maybe<Scalars['String']['output']>;
  /** Project creator */
  user?: Maybe<User>;
};

/** File information */
export type File = {
  __typename?: 'File';
  /** file contents in base64 */
  base64: Scalars['String']['output'];
  /** Date when file was uploaded */
  created_at: Scalars['String']['output'];
  /** Real filename and extention */
  filename: Scalars['String']['output'];
  /** width of the image (only if file is image) */
  height?: Maybe<Scalars['Int']['output']>;
  /** Hint */
  hint?: Maybe<Scalars['String']['output']>;
  /** The id of the file */
  id: Scalars['ID']['output'];
  /** full path to file */
  path: Scalars['String']['output'];
  /** file size in bytes */
  size: Scalars['Int']['output'];
  /** Displaying name of file */
  title: Scalars['String']['output'];
  /** file mimetype */
  type: Scalars['String']['output'];
  /** width of the image (only if file is image) */
  width?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** User authorization */
  auth?: Maybe<Auth>;
  /** Add to Database new Project */
  createProject?: Maybe<Project>;
  /** Create new user */
  createUser?: Maybe<User>;
  /** Remove a Project from database with all project data */
  deleteProject?: Maybe<Scalars['Boolean']['output']>;
  /** Update project fields */
  updateProject?: Maybe<Project>;
  /**
   * Update users fields and return it.
   * It can return **null** if:
   * - you are not authorized;
   * - you are trying to change someone else (not being an admin);
   * - the entry to be modified is not found).
   */
  updateUser?: Maybe<User>;
};


export type MutationAuthArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateProjectArgs = {
  background_base64?: InputMaybe<Scalars['String']['input']>;
  background_info?: InputMaybe<Scalars['String']['input']>;
  calculation_result?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preview_base64?: InputMaybe<Scalars['String']['input']>;
  schema_base64?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatusEnum>;
};


export type MutationCreateUserArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationDeleteProjectArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectArgs = {
  background_base64?: InputMaybe<Scalars['String']['input']>;
  background_info?: InputMaybe<Scalars['String']['input']>;
  calculation_result?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preview_base64?: InputMaybe<Scalars['String']['input']>;
  schema_base64?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatusEnum>;
};


export type MutationUpdateUserArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Information about project */
export type Project = {
  __typename?: 'Project';
  /** Attached file information */
  background?: Maybe<File>;
  /** Additional properties of background, JSON */
  background_info?: Maybe<Scalars['String']['output']>;
  /** Results of model calculation, JSON */
  calculation_result?: Maybe<Scalars['String']['output']>;
  /** External ID of project */
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Int']['output']>;
  /** internal ID of project */
  id: Scalars['ID']['output'];
  /** Name of the project */
  name?: Maybe<Scalars['String']['output']>;
  /** Attached file information */
  pdf?: Maybe<File>;
  /** Attached file information */
  preview?: Maybe<File>;
  /** Attached file information */
  schema?: Maybe<File>;
  /** Base data of partition(sector), JSON */
  sector?: Maybe<Scalars['String']['output']>;
  /** Project status */
  status?: Maybe<ProjectStatusEnum>;
  updated_at?: Maybe<Scalars['Int']['output']>;
  /** Project creator */
  user?: Maybe<User>;
};

/** List of project statuses */
export enum ProjectStatusEnum {
  /** Calculated project */
  Done = 'done',
  /** project is empty, no user data inside */
  New = 'new',
  /** The project was edited by the user, but the calculations cannot be made */
  Saved = 'saved'
}

export type Query = {
  __typename?: 'Query';
  /** This query returns only autorized user or null */
  me?: Maybe<User>;
  nameProject?: Maybe<Scalars['String']['output']>;
  /** Returns list of filtred projects by user_id or code */
  projects?: Maybe<Array<Project>>;
  user: User;
  /** List of users */
  users?: Maybe<Array<User>>;
};


export type QueryProjectsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersArgs = {
  current?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A type */
export type User = {
  __typename?: 'User';
  /** Flag meens that user account is blocked or not */
  active: Scalars['Boolean']['output'];
  /** The city of the user */
  city?: Maybe<Scalars['String']['output']>;
  /** User`s company */
  company?: Maybe<Scalars['String']['output']>;
  /** The email of user */
  email: Scalars['String']['output'];
  /** The id of the user */
  id: Scalars['ID']['output'];
  /** to release additional functionallity for admin users */
  is_admin: Scalars['Boolean']['output'];
  /** Name of the user */
  name?: Maybe<Scalars['String']['output']>;
};
